"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOrderItemToJSON = exports.MenuOrderItemFromJSONTyped = exports.MenuOrderItemFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function MenuOrderItemFromJSON(json) {
    return MenuOrderItemFromJSONTyped(json, false);
}
exports.MenuOrderItemFromJSON = MenuOrderItemFromJSON;
function MenuOrderItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, _1.MenuOrderItemBaseFromJSONTyped)(json, ignoreDiscriminator)), { 'menuItemId': !(0, runtime_1.exists)(json, 'menuItemId') ? undefined : json['menuItemId'], 'subtotal': json['subtotal'], 'tax': json['tax'], 'customizations': !(0, runtime_1.exists)(json, 'customizations') ? undefined : (json['customizations'].map(_1.MenuOrderSubItemFromJSON)) });
}
exports.MenuOrderItemFromJSONTyped = MenuOrderItemFromJSONTyped;
function MenuOrderItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, _1.MenuOrderItemBaseToJSON)(value)), { 'menuItemId': value.menuItemId, 'subtotal': value.subtotal, 'tax': value.tax, 'customizations': value.customizations === undefined ? undefined : (value.customizations.map(_1.MenuOrderSubItemToJSON)) });
}
exports.MenuOrderItemToJSON = MenuOrderItemToJSON;
